/**
 * Limites de mídia alinhados ao WhatsApp / upload da conversa (useMediaUpload).
 */
export const WHATSAPP_MAX_FILE_SIZE_MB = 25;
export const WHATSAPP_MAX_FILE_SIZE_BYTES = WHATSAPP_MAX_FILE_SIZE_MB * 1024 * 1024;
export const WHATSAPP_MAX_VIDEO_INLINE_BYTES = 16 * 1024 * 1024;

/** Accept padrão do composer de conversa (ChatInputActions). */
export const WHATSAPP_CHAT_MEDIA_ACCEPT = 'image/*,video/*';
export const WHATSAPP_CHAT_DOCUMENT_ACCEPT =
    'audio/*,application/pdf,.doc,.docx,.xls,.xlsx';
export const WHATSAPP_CHAT_FILE_ACCEPT = `${WHATSAPP_CHAT_MEDIA_ACCEPT},${WHATSAPP_CHAT_DOCUMENT_ACCEPT}`;

export function assertWhatsAppFileSize(file: File): void {
    if (file.type === 'video/mp4' && file.size > WHATSAPP_MAX_VIDEO_INLINE_BYTES) {
        const sizeMB = (file.size / (1024 * 1024)).toFixed(1);
        throw new Error(
            `Vídeo muito grande (${sizeMB}MB). O WhatsApp permite no máximo 16MB para reprodução inline.`
        );
    }

    if (file.size > WHATSAPP_MAX_FILE_SIZE_BYTES) {
        const sizeMB = (file.size / (1024 * 1024)).toFixed(1);
        throw new Error(`Arquivo muito grande (${sizeMB}MB). Limite: ${WHATSAPP_MAX_FILE_SIZE_MB}MB`);
    }
}
